import styles from './secondaryBackButton.module.css';
import TextButton from '../../TextButton/TextButton';
import { ReactNode } from 'react';
import { toKebabCase } from '../../../../utils/casing';
import { WithTestId } from '../../../../types';
import Icon from '../../../Icon';

export interface SecondaryBackButtonProps extends WithTestId {
  onClick: () => void;
  children: ReactNode | string;
}

const SecondaryBackButton = ({
  onClick,
  children,
  dataTestIdPrefix,
}: SecondaryBackButtonProps) => (
  <TextButton
    onClick={onClick}
    dataTestIdPrefix={toKebabCase(dataTestIdPrefix, 'backButton')}
  >
    <div className={styles.backButtonSecondaryContentWrapper}>
      <Icon name="arrowLeft" size={24} />
      {children}
    </div>
  </TextButton>
);

export default SecondaryBackButton;
